export default "__VITE_ASSET__BeYB85eM__"